import { ArticleType, CategoryType } from 'helpers/strapi/types'
import { ArticlesGrid } from 'routes/Articles/components/ArticlesGrid'
import { ArticlesPreview } from 'routes/Articles/components/ArticlePreview'
import { InnerPageLayout } from 'routes/layouts'
import { HeadMetatags } from 'routes/components/HeadMetatags'
import { JsonViewer } from 'routes/components/JsonViewer'
import { LINKS } from 'routes/constants'
import {
  ArticleBreadcrumbs,
  isBreadcrumb,
} from 'routes/components/Article/ArticleBreadcrumbs'

export function CategoryPage({
  category,
  articles,
}: {
  category: CategoryType
  articles: ArticleType[]
}) {
  if (!category) return null
  const breadcrumbs = [
    { href: '/', name: 'Home' },
    { href: LINKS.ARTICLES, name: 'Blog' },
    {
      name: category?.name,
    },
  ].filter(isBreadcrumb)
  return (
    <InnerPageLayout className={'-mt-7'} isDraft>
      <CategoryPageSeo category={category} />

      <div className={'max-w-4xl'}>
        <ArticleBreadcrumbs breadcrumbs={breadcrumbs} />
        <h1>{category.name}</h1>
        {category.description && <p>{category.description}</p>}
      </div>
      <ArticlesGrid>
        {articles.map((article, i) => (
          <ArticlesPreview
            variant={getArticlePreviewVariantBasedOnIndex(i)}
            article={article}
            key={article.slug}
            showCategory={false}
          />
        ))}
      </ArticlesGrid>
      <JsonViewer json={category} title={'JSON: category'} />
      <JsonViewer json={articles} title={'JSON: articles'} />
    </InnerPageLayout>
  )
}

function CategoryPageSeo({ category }: { category: CategoryType }) {
  const { name, description } = category

  return (
    <HeadMetatags title={name} description={description}>
      <link
        key='canonical'
        rel='canonical'
        href={`${process.env.NEXT_PUBLIC_SITE_URI}${LINKS.ARTICLES}`}
      />
    </HeadMetatags>
  )
}

function getArticlePreviewVariantBasedOnIndex(index: number) {
  if (index <= 2) return 'medium'
  return 'small'
}
